<template>
  <div class="wrap-me">
    <div class="image" />
    <div class="name">Hi, my name is {{ name }}</div>
    <div class="wrap-details">
      <div class="detail">I like software, beer and palm trees</div>
      <div class="detail">
        Visit my
        <a class="link" href="https://blog.jasofalcon.com">blog</a>!
      </div>
      <div class="detail">
        Get in touch
        <a class="link" href="mailto:me@jsaofalcon.com">me@jasofalcon.com</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Me',
  props: {
    name: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrap-me {
  padding: 20px;
  margin-top: 50px;
}

.image {
  border-radius: 50%;
  width: 200px;
  height: 200px;
  background-position: center;
  background-image: url(/img/me.jpg);
  background-size: cover;
  margin: 0 auto;
}
.name {
  margin-top: 20px;
}
.detail {
  margin: 5px;
}

.link {
  font-weight: bold;
  font-style: italic;
  text-decoration: none;
}
</style>
